import { Link as RouterLink } from 'react-router-dom';
import Link from '@mui/material/Link';
import { DASHBOARD_PATH } from '@app/config';
import LogoSmall from '@components/common/LogoSmall';
import Logo from '@components/common/Logo';
import { handlerDrawerOpen, useGetMenuMaster } from '@api/menu';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import { IconChevronsLeft, IconChevronsRight } from '@tabler/icons-react';
import Box from '@mui/material/Box';

function LogoSection() {
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster?.isDashboardDrawerOpened;

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      flexGrow="1"
      borderBottom="1px solid #eaecf0"
      paddingBottom={2}
    >
      {drawerOpen ? (
        <Link
          component={RouterLink}
          to={DASHBOARD_PATH}
          aria-label="theme-logo"
          sx={{
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
            textDecoration: 'none',
          }}
        >
          <Logo />
        </Link>
      ) : (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
          }}
        >
          <IconButton
            size="small"
            onClick={() => handlerDrawerOpen(!drawerOpen)}
          >
            <IconChevronsRight stroke={1.5} size="20px" />
          </IconButton>
          <Link
            component={RouterLink}
            to={DASHBOARD_PATH}
            aria-label="theme-logo"
            sx={{
              display: 'flex',
              alignItems: 'center',
              position: 'relative',
              textDecoration: 'none',
            }}
          >
            <LogoSmall />
          </Link>
        </Box>
      )}

      {drawerOpen && (
        <Tooltip title="Collapse Menu">
          <IconButton
            size="small"
            onClick={() => handlerDrawerOpen(!drawerOpen)}
          >
            <IconChevronsLeft stroke={1.5} size="20px" />
          </IconButton>
        </Tooltip>
      )}
    </Stack>
  );
}

export default LogoSection;
